import { AxiosResponse, AxiosRequestConfig } from 'axios'
import * as qs from 'query-string'

import { scansApi } from '.'

import { File } from '../interfaces/File.interface'
import { QACheck } from '../interfaces/QACheck.interface'

export type FetchQAChecksQuery = {
	vin?: string
	toDate?: string
	fromDate: string
}

export const getQAChecksList = (filterParams: FetchQAChecksQuery) => {
	const axiosConfig: AxiosRequestConfig = {
		params: filterParams,
		paramsSerializer: (p) => qs.stringify(p),
	}

	return scansApi
		.get<QACheck[]>('/qa-check', axiosConfig)
		.then((response: AxiosResponse) => response.data)
}

export const getQACheckFiles = (qaCheckId: string) => (
  scansApi.get<File[]>(`/qa-check/${qaCheckId}/files`)
    .then((response: AxiosResponse) => response.data)
)



// WEBPACK FOOTER //
// ./src/lib/api/qaChecks.ts